import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAxios from "vue-axios";
import App from "./App.vue";
import axios from "axios";
import { globalHost } from "./utils/utils.js";
import { Message } from "element-ui";
import router from "./router";

Vue.config.productionTip = false;
Vue.use(ElementUI, VueAxios, axios);
Vue.prototype.$axios = axios;

// 请求拦截器
axios.interceptors.request.use(
  (req) => {
    if (req.url !== globalHost + "/api/users/login") {
      let token = sessionStorage.getItem("token");
      req.headers.Authorization = "JWT " + token;
    }
    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    return Promise.reject(err.response);
  }
);

Vue.prototype.host = globalHost;

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
